export default "__VITE_ASSET__BGqH1X0c__"